import * as types from './action-types';
import axios from 'axios';
import { apiATC, meekroDB } from '../config';

// Helper for error logging
const logError = error => console.error(error);

// Helper for GET requests
const getRequest = (url, type) => dispatch =>
    axios.get(url)
        .then(res => dispatch({ type, payload: res.data }))
        .catch(logError);

// Helper for POST requests
const postRequest = (url, data, type) => dispatch =>
    axios.post(url, data)
        .then(res => dispatch({ type, payload: res.data }))
        .catch(logError);

// Helper for PUT requests
const putRequest = (url, data, type) => dispatch =>
    axios.put(url, data)
        .then(res => dispatch({ type, payload: res.data }))
        .catch(logError);

// Auth actions
export const setAuthentification = isLoggedIn => ({
    type: types.SET_AUTHENTIFICATION,
    payload: isLoggedIn
});

export const setSearch = search => ({
    type: types.SET_SEARCH,
    payload: search
});

export const setLogin = (user, password) => async dispatch => {
    try {
        const data = {
            user: user.toLowerCase(),
            password: password.toLowerCase()
        };
        const res = await axios.post(`${apiATC}/user/login.php?action=login`, data);
        const userData = res.data;
        if (!userData.length) {
            dispatch({ type: types.GET_USER, payload: -1 });
            return false;
        }
        if (![1, 5, 6].includes(userData[0].role)) {
            window.location.href = "https://www.atcjoaillerie.fr/";
            return false;
        }
        if (userData[0].id_user) {
            axios.post(`${apiATC}/user/login.php?action=log`, { id_user: userData[0].id_user }).catch(logError);
        }
        localStorage.setItem('user', JSON.stringify(userData));
        dispatch({ type: types.GET_USER, payload: userData });
        return true;
    } catch (error) {
        logError(error);
        return false;
    }
};

// Simple actions
export const setOfToEdit = of => ({ type: types.SET_OF_TO_EDIT, payload: of });
export const addOf = of => ({ type: types.ADD_OF, payload: of });
export const addOfToFact = of => ({ type: types.ADD_OF_TO_FACT, payload: of });
export const deleteOfToFact = of => ({ type: types.DELETE_OF_TO_FACT, payload: of });
export const updateOf = of => ({ type: types.UPDATE_OF, payload: of });
export const deleteOf = of => ({ type: types.DELETE_OF, payload: of });
export const deleteOfs = () => ({ type: types.DELETE_OFS });
export const incrementActionCount = () => ({ type: types.INCREMENT_ACTIONS_COUNT });
export const addRessource = () => ({ type: types.ADD_RESSOURCE });

// Async actions using helpers
export const setProduit = (cv, centre) =>
    getRequest(`${apiATC}/produit/produit.php?action=detail&cv=${cv}&idp=${centre}`, types.SET_PRODUIT);

export const getCours = () =>
    getRequest(`${meekroDB}/general.php?table=cours&orderBy=description`, types.GET_COURS);

export const getAtelier = () =>
    getRequest(`${apiATC}/atelier/ouvrier.php?action=liste_joaillier`, types.GET_ATELIER);

export const getTypeCom = () =>
    getRequest(`${meekroDB}/general.php?table=type_comission`, types.GET_TYPE_COM);

export const getTypeProduit = () =>
    getRequest(`${apiATC}/general.php?table=type_produit&orderBy=description`, types.GET_LISTE_TYPE_PRODUIT);

export const getTypeTarif = () =>
    getRequest(`${apiATC}/general.php?table=tarif_produit&orderBy=description`, types.GET_TYPE_TARIF);

export const getStatut = () =>
    getRequest(`${meekroDB}/general.php?table=t_statuts&orderBy=OF_interne`, types.GET_LISTE_STATUT);

export const getTypeTransport = () =>
    getRequest(`${meekroDB}/general.php?table=type_transport&orderBy=description`, types.GET_TYPE_TRANSPORT);

export const getMetaux = () =>
    getRequest(`${meekroDB}/general.php?table=type_metal&orderBy=description`, types.GET_LISTE_METAUX);

// Nouvelle liste Metal (table metal) distincte de type_metal
export const getListeMetal = () =>
    getRequest(`${apiATC}/general.php?table=metal`, types.GET_LISTE_METAL);

export const getStade = () =>
    getRequest(`${meekroDB}/general.php?table=stade&orderBy=description`, types.GET_LISTE_STADE);

export const getListeJoaillier = () =>
    getRequest(`${apiATC}/general.php?table=joaillier&orderBy=label`, types.GET_LISTE_JOAILLIER);

export const getListeTypePierre = () =>
    getRequest(`${meekroDB}/general.php?table=type_pier&orderBy=description`, types.GET_LISTE_TYPE_PIERRE);

export const getListeFormePierre = () =>
    getRequest(`${meekroDB}/general.php?table=forme_pier&orderBy=description`, types.GET_LISTE_FORME_PIERRE);

export const getListeCouleurPierre = () =>
    getRequest(`${meekroDB}/general.php?table=couleur&orderBy=description`, types.GET_LISTE_COULEUR_PIERRE);

export const getListeQualitePierre = () =>
    getRequest(`${meekroDB}/general.php?table=qualite&orderBy=description`, types.GET_LISTE_QUALITE_PIERRE);

export const getListeEtatPierre = () =>
    getRequest(`${meekroDB}/general.php?table=pierres_recues_etat&orderBy=description`, types.GET_LISTE_ETAT_PIERRE);

export const getListeBoiteOr = () =>
    getRequest(`${meekroDB}/atelier/boite_or.php`, types.GET_LISTE_BOITE_OR);

export const getListeSertisseur = () =>
    getRequest(`${apiATC}/general.php?table=sertisseur&orderBy=label`, types.GET_LISTE_SERTISSEUR);

export const getListeFournisseur = () =>
    getRequest(`${apiATC}/general.php?table=fournisseur&orderBy=raison_soc`, types.GET_LISTE_FOURNISSEUR);

export const getListePierre = () =>
    getRequest(`${apiATC}/pierre/pierre.php?action=liste`, types.GET_LISTE_PIERRE);

export const getListeRetourPierre = () =>
    getRequest(`${meekroDB}/general.php?table=pierre_retour`, types.GET_LISTE_RETOUR_PIERRE);

export const getListeTva = () =>
    getRequest(`${meekroDB}/general.php?table=tva`, types.GET_TYPE_TVA);

export const getTypeCommande = () =>
    getRequest(`${meekroDB}/general.php?table=type_commande`, types.GET_TYPE_COMMANDE);

export const getListeConfiePierre = () =>
    getRequest(`${meekroDB}/pierre/confie.php`, types.GET_LISTE_CONFIE_PIERRE);

export const getListeAtelier = (of = '') =>
    getRequest(`${apiATC}/of/atelier.php?of=${of}`, types.GET_LISTE_ATELIER);

export const getListeOfSerti = (of = '') =>
    postRequest(`${meekroDB}/atelier/serti.php?of=${of}`, {}, types.GET_LISTE_OF_SERTI);

export const getListeProduit = () =>
    getRequest(`${apiATC}/produit/produit.php?action=liste`, types.GET_LISTE_PRODUIT);

export const getStockProduit = () =>
    postRequest(`${apiATC}/produit/stock.php?action=liste`, {}, types.GET_STOCK_PRODUIT);

export const getListeImage = () =>
    getRequest(`${meekroDB}/images/liste.php`, types.GET_LISTE_IMAGE);

export const getListeAvoir = () =>
    getRequest(`${meekroDB}/avoir/avoir.php`, types.GET_LISTE_AVOIR);

export const getListeOf = (of = '') =>
    getRequest(`${meekroDB}/of/of.php?id=${of}`, types.GET_OFS);

export const getOfFromId = id =>
    postRequest(`${apiATC}/of/trace_of.php?of=${id}`, {}, types.GET_OF_FROM_ID);

export const getListeOfFacturation = () =>
    getRequest(`${apiATC}/of/facturation.php`, types.GET_OFS_FACTURATION);

export const getListeClient = () =>
    getRequest(`${apiATC}/client/liste.php`, types.GET_LISTE_CLIENT);

// Analyse actions
export const getOfEnCours = (filtre = []) =>
    putRequest(`${meekroDB}/of/analyse_of.php`, filtre, types.GET_OF_EN_COURS);

export const getOfLivre = (filtre = []) =>
    postRequest(`${meekroDB}/of/analyse_of.php`, filtre, types.GET_OF_LIVRE);

export const getOfLivreExtensia = (filtre = []) =>
    postRequest(`${meekroDB}/of/analyse_extensia.php`, filtre, types.GET_OF_LIVRE_EXTENSIA);

export const getCaGroupedByMonth = (filtre = []) =>
    putRequest(`${meekroDB}/analyse/analyse_ca.php?action=ca_par_mois`, filtre, types.GET_CA_GROUPED_BY_MONTH);

export const getComparaisonCaMois = (filtre = []) =>
    putRequest(`${meekroDB}/analyse/analyse_ca.php?action=ca_par_mois_comparaison`, filtre, types.GET_COMPARAION_CA_GROUPED_BY_MONTH);

export const getComparaisonCaAn = (filtre = []) =>
    putRequest(`${meekroDB}/analyse/analyse_ca.php?action=ca_par_annee`, filtre, types.GET_COMPARAION_CA_GROUPED_BY_YEAR);

export const getAnalyseCa = (filtre = []) =>
    putRequest(`${meekroDB}/analyse/analyse_ca.php?action=top_vente`, filtre, types.GET_ANALYSE_CA);

export const getAnalyseCaParTranche = (filtre = []) =>
    postRequest(`${meekroDB}/analyse/analyse_ca.php?action=analyse_ca_tranche`, filtre, types.GET_ANALYSE_TRANCHE);

export const getAnalyseCaParTarif = (filtre = []) =>
    postRequest(`${meekroDB}/analyse/analyse_ca.php?action=analyse_type_tarif`, filtre, types.GET_ANALYSE_CA_TARIF);

export const getAnalyseMetal = (filtre = []) =>
    postRequest(`${meekroDB}/analyse/analyse_ca.php?action=analyse_metal`, filtre, types.GET_ANALYSE_METAL);

export const getAnalyseFournisseur = (filtre = []) =>
    postRequest(`${meekroDB}/analyse/analyse_fournisseur.php`, filtre, types.GET_ANALYSE_FOURNISSEUR);

// Specific action
export const modifTarifProd = id =>
    // getRequest(`${meekroDB}/produit/modif_tarif_produit.php?centres=${id}`, '');
    getRequest(`${apiATC}/produit/revalorisation_tarif.php?centres=${id}`, '');

// ================= MOUVEMENTS OR CRUD (UNIFIE Fournisseur / Client) =================
const mouvementsMetalEndpoint = `${apiATC}/atelier/mouvements_metal.php`;

export const fetchMouvementsOr = () => dispatch =>
    axios.get(mouvementsMetalEndpoint)
        .then(res => dispatch({ type: types.GET_MOUVEMENTS_OR, payload: (res.data && res.data.data) || [] }))
        .catch(logError);

export const createMouvementOr = (payload) => dispatch =>
    axios.post(mouvementsMetalEndpoint, payload)
        .then(res => { dispatch(fetchMouvementsOr()); return res.data; })
        .catch(err => { logError(err); throw err; });

export const updateMouvementOr = (id, payload) => dispatch =>
    axios.put(`${mouvementsMetalEndpoint}?id=${id}`, payload)
        .then(res => { dispatch(fetchMouvementsOr()); return res.data; })
        .catch(err => { logError(err); throw err; });

export const deleteMouvementOr = (id) => dispatch =>
    axios.delete(`${mouvementsMetalEndpoint}?id=${id}`)
        .then(res => { dispatch({ type: types.DELETE_MOUVEMENT_OR, payload: id }); return res.data; })
        .catch(err => { logError(err); throw err; });

// ================= MOUVEMENTS OR CLIENTS (entity=client) =================
export const fetchMouvementsOrClient = () => dispatch =>
    axios.get(`${mouvementsMetalEndpoint}?entity=client`)
        .then(res => dispatch({ type: types.GET_MOUVEMENTS_OR_CLIENT, payload: (res.data && res.data.data) || [] }))
        .catch(logError);

export const createMouvementOrClient = (payload) => dispatch => {
    // Pour les clients, pas de conversion automatique - les valeurs restent comme saisies
    const adapted = { ...payload };
    // Si c'est une entrée client (entreeOrFin > 0), ne pas toucher aux sorties
    // Si c'est une sortie client, utiliser sortie_or_fin plutôt que sortie_or_750
    if (adapted.sortieOr750 != null && adapted.sortie_or_fin == null && (!adapted.entreeOrFin || parseFloat(adapted.entreeOrFin) === 0)) {
        adapted.sortie_or_fin = adapted.sortieOr750;
    }
    return axios.post(`${mouvementsMetalEndpoint}?entity=client`, adapted)
        .then(res => { dispatch(fetchMouvementsOrClient()); return res.data; })
        .catch(err => { logError(err); throw err; });
};

export const updateMouvementOrClient = (id, payload) => dispatch => {
    // Pour les clients, pas de conversion automatique - les valeurs restent comme saisies
    const adapted = { ...payload };
    // Si c'est une entrée client (entreeOrFin > 0), ne pas toucher aux sorties
    // Si c'est une sortie client, utiliser sortie_or_fin plutôt que sortie_or_750
    if (adapted.sortieOr750 != null && adapted.sortie_or_fin == null && (!adapted.entreeOrFin || parseFloat(adapted.entreeOrFin) === 0)) {
        adapted.sortie_or_fin = adapted.sortieOr750;
    }
    return axios.put(`${mouvementsMetalEndpoint}?entity=client&id=${id}`, adapted)
        .then(res => { dispatch(fetchMouvementsOrClient()); return res.data; })
        .catch(err => { logError(err); throw err; });
};

export const deleteMouvementOrClient = (id) => dispatch =>
    axios.delete(`${mouvementsMetalEndpoint}?entity=client&id=${id}`)
        .then(res => { dispatch({ type: types.DELETE_MOUVEMENT_OR_CLIENT, payload: id }); return res.data; })
        .catch(err => { logError(err); throw err; });

// ================= MOUVEMENTS CLAL =================
// Endpoint dédié (à créer côté backend) : atelier/mouvements_clal.php
const mouvementsClalEndpoint = `${apiATC}/atelier/mouvements_clal.php`;

export const fetchMouvementsClal = () => dispatch =>
    axios.get(mouvementsClalEndpoint)
        .then(res => dispatch({ type: types.GET_MOUVEMENTS_CLAL, payload: (res.data && res.data.data) || [] }))
        .catch(logError);

export const createMouvementClal = (payload) => dispatch =>
    {
        const normPrix = (v) => {
            if (v === null || v === undefined || v === '') return null;
            const s = String(v).replace(/[,]/g, '.').replace(/[^0-9.-]/g, '');
            const n = parseFloat(s);
            return isNaN(n) ? null : Number(n.toFixed(2));
        };
        const adapted = { ...payload };
        if (typeof adapted.achat !== 'undefined') adapted.achat = adapted.achat ? 1 : 0;
        if (typeof adapted.prix_achat !== 'undefined') adapted.prix_achat = normPrix(adapted.prix_achat);
        return axios.post(mouvementsClalEndpoint, adapted)
        .then(res => { dispatch(fetchMouvementsClal()); return res.data; })
        .catch(err => { logError(err); throw err; });
    };
export const updateMouvementClal = (id, payload) => dispatch =>
    {
        const normPrix = (v) => {
            if (v === null || v === undefined || v === '') return null;
            const s = String(v).replace(/[,]/g, '.').replace(/[^0-9.-]/g, '');
            const n = parseFloat(s);
            return isNaN(n) ? null : Number(n.toFixed(2));
        };
        const adapted = { ...payload };
        if (typeof adapted.achat !== 'undefined') adapted.achat = adapted.achat ? 1 : 0;
        if (typeof adapted.prix_achat !== 'undefined') adapted.prix_achat = normPrix(adapted.prix_achat);
        return axios.put(`${mouvementsClalEndpoint}?id=${id}`, adapted)
        .then(res => { dispatch(fetchMouvementsClal()); return res.data; })
        .catch(err => { logError(err); throw err; });
    };
export const deleteMouvementClal = (id) => dispatch =>
    axios.delete(`${mouvementsClalEndpoint}?id=${id}`)
        .then(res => { dispatch({ type: types.DELETE_MOUVEMENT_CLAL, payload: id }); return res.data; })
        .catch(err => { logError(err); throw err; });

// ================= CONTENANTS & PESEES (ATELIER) =================
// Endpoints attendus côté backend PHP
const contenantsEndpoint = `${apiATC}/atelier/contenants.php`;
const peseesEndpoint = `${apiATC}/atelier/pesees.php`;

// Contenants CRUD
export const fetchContenants = () => dispatch =>
    axios.get(contenantsEndpoint)
        .then(res => {
            const payload = Array.isArray(res.data) ? res.data : (res.data && res.data.data) || [];
            dispatch({ type: types.GET_CONTENANTS, payload });
        })
        .catch(logError);

export const createContenant = (payload) => dispatch =>
    axios.post(contenantsEndpoint, payload)
        .then(res => { dispatch(fetchContenants()); return res.data; })
        .catch(err => { logError(err); throw err; });

export const updateContenant = (id, payload) => dispatch =>
    axios.put(`${contenantsEndpoint}?id=${id}`, payload)
        .then(res => { dispatch(fetchContenants()); return res.data; })
        .catch(err => { logError(err); throw err; });

export const deleteContenant = (id) => dispatch =>
    axios.delete(`${contenantsEndpoint}?id=${id}`)
        .then(res => { dispatch({ type: types.DELETE_CONTENANT, payload: id }); return res.data; })
        .catch(err => { logError(err); throw err; });

// Pesées CRUD
export const fetchPesees = () => dispatch =>
    axios.get(peseesEndpoint)
        .then(res => {
            const payload = Array.isArray(res.data) ? res.data : (res.data && res.data.data) || [];
            dispatch({ type: types.GET_PESEES, payload });
        })
        .catch(logError);

export const createPesee = (payload) => dispatch =>
    axios.post(peseesEndpoint, payload)
        .then(res => { dispatch(fetchPesees()); return res.data; })
        .catch(err => { logError(err); throw err; });

export const updatePesee = (id, payload) => dispatch =>
    axios.put(`${peseesEndpoint}?id=${id}`, payload)
        .then(res => { dispatch(fetchPesees()); return res.data; })
        .catch(err => { logError(err); throw err; });

export const deletePesee = (id) => dispatch =>
    axios.delete(`${peseesEndpoint}?id=${id}`)
        .then(res => { dispatch({ type: types.DELETE_PESEE, payload: id }); return res.data; })
        .catch(err => { logError(err); throw err; });

// Analyse Marges actions
export const getAnalyseMarges = (filters, action = 'analyse_marge_detaille') => dispatch =>
    axios.post(`${apiATC}/analyse/analyse_marge_service.php?action=${action}`, filters)
        .then(res => {
            switch(action) {
                case 'analyse_marge_totaux':
                    dispatch({ type: types.GET_ANALYSE_MARGE_TOTAUX, payload: res.data });
                    break;
                case 'analyse_marge_par_classe':
                    dispatch({ type: types.GET_ANALYSE_MARGE_CLASSES, payload: res.data });
                    break;
                case 'analyse_marge_detaille':
                    dispatch({ type: types.GET_ANALYSE_MARGE_DETAILS, payload: res.data });
                    break;
                case 'analyse_marge_top_efficacite':
                    dispatch({ type: types.GET_ANALYSE_MARGE_EFFICACITE, payload: res.data });
                    break;
                default:
                    break;
            }
            return res.data;
        })
        .catch(logError);

export const getAnalyseMargeTotaux = (filters) => dispatch =>
    getAnalyseMarges(filters, 'analyse_marge_totaux')(dispatch);

export const getAnalyseMargeClasses = (filters) => dispatch =>
    getAnalyseMarges(filters, 'analyse_marge_par_classe')(dispatch);

export const getAnalyseMargeDetails = (filters) => dispatch =>
    getAnalyseMarges(filters, 'analyse_marge_detaille')(dispatch);

export const getAnalyseMargeEfficacite = (filters) => dispatch =>
    getAnalyseMarges(filters, 'analyse_marge_top_efficacite')(dispatch);

// Analyse Marges Livrées actions  
export const getAnalyseMargesLivres = (filters, action = 'analyse_marge_detaille_livres') => dispatch =>
    axios.post(`${apiATC}/analyse/analyse_marge_service.php?action=${action}`, filters)
        .then(res => {
            switch(action) {
                case 'analyse_marge_totaux_livres':
                    dispatch({ type: types.GET_ANALYSE_MARGE_TOTAUX_LIVRES, payload: res.data });
                    break;
                case 'analyse_marge_par_classe_livres':
                    dispatch({ type: types.GET_ANALYSE_MARGE_CLASSES_LIVRES, payload: res.data });
                    break;
                case 'analyse_marge_detaille_livres':
                    dispatch({ type: types.GET_ANALYSE_MARGE_DETAILS_LIVRES, payload: res.data });
                    break;
                case 'analyse_marge_top_efficacite_livres':
                    dispatch({ type: types.GET_ANALYSE_MARGE_EFFICACITE_LIVRES, payload: res.data });
                    break;
                default:
                    break;
            }
            return res.data;
        })
        .catch(logError);

export const getAnalyseMargeTotauxLivres = (filters) => dispatch =>
    getAnalyseMargesLivres(filters, 'analyse_marge_totaux_livres')(dispatch);

export const getAnalyseMargeClassesLivres = (filters) => dispatch =>
    getAnalyseMargesLivres(filters, 'analyse_marge_par_classe_livres')(dispatch);

export const getAnalyseMargeDetailsLivres = (filters) => dispatch =>
    getAnalyseMargesLivres(filters, 'analyse_marge_detaille_livres')(dispatch);

export const getAnalyseMargeEfficaciteLivres = (filters) => dispatch =>
    getAnalyseMargesLivres(filters, 'analyse_marge_top_efficacite_livres')(dispatch);

// ================= DEVIS =================
const devisEndpoint = `${apiATC}/produit/devis.php`;

const getUserId = () => {
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        return user?.[0]?.id_user ?? null;
    } catch { return null; }
};

const normalizeDevis = (row) => ({
    id:              row.front_id,
    savedAt:         row.saved_at ? new Date(row.saved_at).getTime() : Date.now(),
    permanent:       row.permanent === '1' || row.permanent === 1 || row.permanent === true,
    refClient:       row.ref_client || '',
    refBase:         row.ref_base || '',
    client:          row.data?.client || null,
    selectedProduct: row.data?.selectedProduct || null,
    fields:          row.data?.fields || {},
    stones:          row.data?.stones || [],
    coeffs:          row.data?.coeffs || {},
    prix:            parseFloat(row.prix) || 0,
});

export const fetchDevis = () => dispatch => {
    return axios.get(`${devisEndpoint}?action=list`)
        .then(res => {
            const normalized = Array.isArray(res.data) ? res.data.map(normalizeDevis) : [];
            dispatch({ type: types.GET_LISTE_DEVIS, payload: normalized });
        })
        .catch(logError);
};

export const saveDevis = (snapshot) => dispatch => {
    const id_user = getUserId();
    if (!id_user) return Promise.reject('Non connecté');
    const body = {
        id_user,
        id:         snapshot.id,
        refClient:  snapshot.refClient,
        refBase:    snapshot.refBase,
        label:      snapshot.refClient || snapshot.refBase || (snapshot.client?.label) || 'Devis',
        permanent:  snapshot.permanent,
        client_key: snapshot.client?.id ?? null,
        prix:       snapshot.prix || 0,
        data: {
            fields:          snapshot.fields,
            stones:          snapshot.stones,
            coeffs:          snapshot.coeffs,
            client:          snapshot.client,
            selectedProduct: snapshot.selectedProduct,
        },
    };
    return axios.post(`${devisEndpoint}?action=save`, body)
        .then(res => {
            const type = res.data.action === 'updated' ? types.UPDATE_DEVIS : types.ADD_DEVIS;
            dispatch({ type, payload: { ...snapshot, id_user } });
            return res.data;
        })
        .catch(logError);
};

export const deleteDevis = (frontId) => dispatch => {
    const id_user = getUserId();
    if (!id_user) return;
    return axios.post(`${devisEndpoint}?action=delete&front_id=${frontId}&id_user=${id_user}`, {})
        .then(() => dispatch({ type: types.DELETE_DEVIS, payload: frontId }))
        .catch(logError);
};
